require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./using-private-npm-packages-on-netlify.json") })
        }
      }, "path---using-private-npm-packages-on-netlify");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---using-private-npm-packages-on-netlify!./.cache/json/using-private-npm-packages-on-netlify.json
// module id = 333
// module chunks = 231608221292675